import type { AccountPlatform } from "@talismn/crypto"
import type { FC } from "react"

export const TalismanOrbLogo: FC<{ platform: AccountPlatform }> = ({ platform }) => {
  switch (platform) {
    case "ethereum":
      return (
        <g opacity="0.75" transform="scale(0.7) translate(14 14)" className="orb-type">
          <path
            d="M12.8101 32.76L32.0001 44.62L51.1901 32.76L32.0001 -0.0699997L12.8101 32.76Z"
            fill="white"
          />
          <path
            d="M12.8101 36.48L32.0001 48.43L51.1901 36.48L32.0001 63.93L12.8101 36.48Z"
            fill="white"
          />
        </g>
      )
    case "polkadot":
      return (
        <g
          opacity="0.75"
          transform="scale(1.0323) translate(14 12)"
          fill="white"
          className="orb-type"
        >
          <circle cx="16.9926" cy="2.83173" r="2.83173" />
          <circle cx="9.91302" cy="7.47004" r="2.83173" />
          <circle cx="24.0705" cy="7.47004" r="2.83173" />
          <circle cx="16.9926" cy="10.8874" r="2.83173" />
          <circle cx="2.83173" cy="11.1316" r="2.83173" />
          <circle cx="31.1501" cy="11.1316" r="2.83173" />
          <circle cx="9.91302" cy="15.2815" r="2.83173" />
          <circle cx="24.0705" cy="15.2815" r="2.83173" />
          <circle cx="2.83173" cy="18.6993" r="2.83173" />
          <circle cx="16.9926" cy="18.9433" r="2.83173" />
          <circle cx="31.1501" cy="18.6993" r="2.83173" />
          <circle cx="9.91302" cy="23.0931" r="2.83173" />
          <circle cx="24.0705" cy="23.0931" r="2.83173" />
          <circle cx="2.83173" cy="26.2667" r="2.83173" />
          <circle cx="16.9926" cy="26.999" r="2.83173" />
          <circle cx="31.1501" cy="26.2667" r="2.83173" />
          <circle cx="9.91302" cy="30.905" r="2.83173" />
          <circle cx="24.0705" cy="30.905" r="2.83173" />
          <circle cx="16.9926" cy="35.0548" r="2.83173" />
        </g>
      )
    case "solana":
      return (
        <g opacity="0.75" className="orb-type" transform="scale(0.45) translate(37.5, 37.5)">
          <path
            d="M70.6648 50.1769L58.9393 62.775C58.6844 63.0486 58.376 63.2668 58.0332 63.4159C57.6905 63.5651 57.3208 63.6419 56.9472 63.6417H1.36128C1.09605 63.6417 0.836598 63.5641 0.614804 63.4184C0.393011 63.2727 0.218536 63.0652 0.112817 62.8215C0.00709765 62.5779 -0.0252603 62.3085 0.0197186 62.0467C0.0646974 61.7848 0.185054 61.5418 0.366 61.3476L12.1006 48.7496C12.3548 48.4766 12.6623 48.2589 13.0039 48.1098C13.3455 47.9607 13.714 47.8834 14.0866 47.8828H69.6695C69.9348 47.8828 70.1942 47.9604 70.416 48.1062C70.6378 48.2519 70.8123 48.4593 70.918 48.703C71.0237 48.9467 71.0561 49.216 71.0111 49.4778C70.9661 49.7397 70.8458 49.9827 70.6648 50.1769V50.1769ZM58.9393 24.8081C58.6844 24.5345 58.376 24.3163 58.0332 24.1672C57.6905 24.0181 57.3208 23.9412 56.9472 23.9414H1.36128C1.09605 23.9414 0.836598 24.019 0.614804 24.1647C0.393011 24.3105 0.218536 24.5179 0.112817 24.7616C0.00709765 25.0053 -0.0252603 25.2746 0.0197186 25.5364C0.0646974 25.7983 0.185054 26.0413 0.366 26.2355L12.1006 38.8336C12.3548 39.1065 12.6623 39.3242 13.0039 39.4733C13.3455 39.6224 13.714 39.6997 14.0866 39.7003H69.6695C69.9348 39.7003 70.1942 39.6227 70.416 39.477C70.6378 39.3313 70.8123 39.1238 70.918 38.8801C71.0237 38.6365 71.0561 38.3671 71.0111 38.1053C70.9661 37.8434 70.8458 37.6004 70.6648 37.4062L58.9393 24.8081ZM1.36128 15.7589H56.9472C57.3208 15.7591 57.6905 15.6822 58.0332 15.5331C58.376 15.384 58.6844 15.1658 58.9393 14.8922L70.6648 2.29413C70.8458 2.09986 70.9661 1.85688 71.0111 1.59502C71.0561 1.33317 71.0237 1.06385 70.918 0.820169C70.8123 0.576485 70.6378 0.369047 70.416 0.223341C70.1942 0.0776352 69.9348 8.97308e-06 69.6695 0L14.0866 0C13.714 0.000635258 13.3455 0.077888 13.0039 0.226975C12.6623 0.376063 12.3548 0.593811 12.1006 0.866739L0.369025 13.4648C0.188254 13.6588 0.0679503 13.9016 0.0228694 14.1631C-0.0222115 14.4247 0.00988974 14.6938 0.115236 14.9373C0.220583 15.1809 0.394595 15.3884 0.615931 15.5343C0.837268 15.6802 1.09631 15.7583 1.36128 15.7589V15.7589Z"
            fill="white"
          />
        </g>
      )
    default:
      return null
  }
}
